import React, { useMemo } from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WImage, Button, WContainer } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './HelpBanner.module.sass'
import ArrowRight from '../../atoms/Icons/ArrowRight'

interface Props {
  item: MenuItemType
  className?: string
}

const HelpBanner = (props: Props) => {
  const { item = undefined, className = '' } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (ty?: string, c?: string, t?: string, cta?: string, e?: string) => {
    const action_timestamp = getTimestamp()
    let dlObj = {}

    switch (e) {
      case 'componente_contatti':
        dlObj = {
          virtual: 'action',
          action_name: 'navigazione',
          action_tech: 'click',
          action_type: cta?.replace(/\-|\s+/g, '_').toLowerCase(),
          action_timestamp,
          action_effect: 'interazione_componente_contatti',
        }
        break
      default:
        dlObj = {
          virtual: 'action',
          action_name: 'contattaci',
          action_tech: 'click',
          action_type: 'accedi',
          action_timestamp,
          action_effect: 'accesso_pagina_contatti',
        }
        break
    }
    linkDataLayer(dlObj)
  }

  const imageBox = useMemo(
    () =>
      item && (
        <WImage
          src={item.image}
          alt={item.name}
          title={item.name}
          maxWidth={655}
          maxHeight={257}
          layout="intrinsic"
          objectFit="contain"
        />
      ),
    [item?.image]
  )

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <span className={styles.bgTop} />
      <span className={styles.bgBottom} />
      <WContainer>
        <div className={`${styles.layout}`}>
          <div className={styles.content}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {!!item.description && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            )}
            {!!item.children?.edges?.filter((x) => !!x.node.url && !!x.node.ctaLabel).length && (
              <div className={styles.ctaBox}>
                {item.children.edges
                  .filter((x) => !!x.node.url && !!x.node.ctaLabel)
                  .map((x) => x.node)
                  .map((x, i) => (
                    <Button
                      key={x.pk}
                      href={x.url}
                      label={x.ctaLabel}
                      color={i === 1 ? 'white' : undefined}
                      variant={i === 1 ? 'ghost' : undefined}
                      icon={i === 1 ? <ArrowRight /> : undefined}
                      iconPos="right"
                      handleTracking={(ty?: string, c?: string, t?: string, cta?: string) => {
                        handleTracking(ty, c, t, cta, 'componente_contatti')
                        handleTracking()
                      }}
                    />
                  ))}
              </div>
            )}
          </div>
          <div className={`${styles.imageBoxWrap}`}>
            <div className={`${styles.imageBox}`}>{imageBox}</div>
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default HelpBanner
